import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { UsuarioFilterItemMarca } from './usuario-filter-item-marca';
import { Representante } from '../../pessoa/representante';

export class UsuarioFilter implements Filter {
    filterPsq: string;
    situacao: number;
    perfil: number;
    idRepresentante: number;
    representante: Representante;
    idGerente: number;
    idAtendente: number;
    itensMarcas: UsuarioFilterItemMarca[];

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        // Perfil
        if (this.perfil) {
            params = params.append('perfil', this.perfil.toString());
        }
        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }
        // Gerente
        if (this.idGerente) {
            params = params.append('idGerente', this.idGerente.toString());
        }
        // Atendente
        if (this.idAtendente) {
            params = params.append('idAtendente', this.idAtendente.toString());
        }
        // Marcas
        if (this.itensMarcas && this.itensMarcas.length > 0) {
            this.itensMarcas.forEach(itemMarca => {
                if (itemMarca.selected) {
                    params = params.append('idItemMarca', itemMarca.id.toString());
                }
            });
        }

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.situacao = null;
        this.perfil = null;
        this.idRepresentante = null;
        this.representante = null;
        this.idGerente = null;
        this.idAtendente = null;
        this.deselectAllItensMarcas();
    }


    /** Desmarca todas as marcas */
    private deselectAllItensMarcas() {
        if (!this.itensMarcas) {
            return;
        }
        this.itensMarcas.forEach(itemMarca => itemMarca.selected = false);
    }

    /** Remove todas as marcas do filter */
    clearMarcas() {
        this.itensMarcas = [];
    }
}
